import { api } from "@/services/api";
import { useAppDispatch } from "@/services/store";
import { LanguageOutlined } from "@mui/icons-material";
import { InputBase, MenuItem, Select, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  fontSize: 20,
  "& > .MuiSelect-select.MuiInputBase-input": {
    paddingTop: 9,
    paddingRight: 28,
  },
  "& .MuiInputBase-input": {
    color: (theme.vars ?? theme).palette.background.paper,
  },
  "& .MuiSelect-icon": {
    color: (theme.vars ?? theme).palette.background.paper,
  },
}));

/**
 * Inspiration by:
 * https://designsystem.digital.gov/patterns/select-a-language/selected-content/
 * https://dev.to/fastly/the-elusive-perfect-language-switcher-2mp9
 */
export function LanguageSelector() {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const handleLanguageChange = async (newLanguage: string) => {
    await i18n.changeLanguage(newLanguage);
    // Since we change the accepted language, all cache has to be reset to retrieve
    // language-specific names
    dispatch(api.util.resetApiState());
  };

  return (
    <Select
      input={<BootstrapInput />}
      size="small"
      value={i18n.resolvedLanguage}
      onChange={async event => {
        await handleLanguageChange(event.target.value);
      }}
      renderValue={value => (
        <div className="flex items-center gap-2">
          <LanguageOutlined />
          {value.toUpperCase()}
        </div>
      )}
    >
      <MenuItem value="en">English</MenuItem>
      <MenuItem value="es">Español</MenuItem>
      <MenuItem value="pt-BR">Português (Brasil)</MenuItem>
      <MenuItem value="fr">Français</MenuItem>
    </Select>
  );
}
